// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    PopulateApiParameter,
    SendDataToApi,
    chain,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/DeclineQuote";
import { UpdateQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { updateQuote as updateQuoteApi } from "@vanmeter/App/Services/QuoteService";

interface XUpdateQuoteApiParameter extends UpdateQuoteApiParameter {
    Message?: string;
    QuoteNumber?: string;
}

export const xPopulateApiParameter: typeof PopulateApiParameter = props => {
    (props.apiParameter as XUpdateQuoteApiParameter) = {
        quoteId: (props.parameter.quote as any).quoteId,
        QuoteNumber: (props.parameter.quote as any).quoteNumber,
        Message: (props.parameter as any).message,
    };
};

export const xSendDataToApi: typeof SendDataToApi = async props => {
    const result = await updateQuoteApi(props.apiParameter as any);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

replaceInChain(chain, PopulateApiParameter, xPopulateApiParameter);
replaceInChain(chain, SendDataToApi, xSendDataToApi);
